import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag.ts";
import { featureFlags as featureFlagsManifest } from "@/utils/feature-flags/feature-flag-manifest.ts";

export const fetchRoutingTable = async () => {
    try {
        const isPreview =
            window.location.search.includes("wacae-preview=true") &&
            process.env["NODE_ENV"] !== "production";

        if (isPreview) {
            console.log(
                "wacae-preview is true, fetching Preview Routing Table"
            );
        }

        const useManagementRoutingTable = checkFeatureFlagGate(
            featureFlagsManifest.wacRoutingTableCutover
        );

        let routingTableUrl: string;
        if (useManagementRoutingTable) {
            const baseUrl = process.env[
                "WAC_MANAGEMENT_ROUTING_TABLE_BASE_URL"
            ] as string;
            const fileName = isPreview
                ? "routing-table-preview.json"
                : process.env["NODE_ENV"] === "production"
                ? "routing-table-production.json"
                : "routing-table-staging.json";
            routingTableUrl = `${baseUrl}/${fileName}`;
        } else {
            routingTableUrl = isPreview
                ? (process.env["ROUTING_TABLE_URL_PREVIEW"] as string)
                : (process.env["ROUTING_TABLE_URL"] as string);
        }

        const response = await fetch(routingTableUrl);
        if (!response.ok) {
            throw new Error(
                `Failed to fetch Routing Table from CloudFront: ${response.status} ${response.statusText}`
            );
        }
        return await response.json();
    } catch (error) {
        console.error("Error fetching Routing Table", error);
    }
};

export const inRoutingTable = (
    segments: string[],
    index: number,
    segLength: number,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    routeObject: any
): boolean => {
    const currSeg = String(segments[index]);
    const hasSeg = routeObject[currSeg];
    const hasWildcard = routeObject["*"];
    const lastSeg = index === segLength;

    let hasSegResult = false;
    let hasWildcardResult = false;

    if (hasSeg) {
        if (lastSeg) {
            hasSegResult = !Boolean(hasSeg["p"]);
        } else {
            hasSegResult = inRoutingTable(
                segments,
                index + 1,
                segLength,
                hasSeg
            );
        }
    }

    if (hasWildcard) {
        if (lastSeg) {
            hasWildcardResult = !Boolean(hasWildcard["p"]);
        } else {
            hasWildcardResult = inRoutingTable(
                segments,
                index + 1,
                segLength,
                hasWildcard
            );
        }
    }

    return hasSegResult || hasWildcardResult;
};
